import ViewAllAwaitingActions from 'components/dashboard/awaitingReview/ViewAllAwaitingActions';

const AwaitingActions = () => {
	return <ViewAllAwaitingActions />;
};
export default AwaitingActions;
